import { FILE_FORMATS } from '../../constants/file-formats';
import { DEFAULT_APPROVED_CREDIT_LINE_AMOUNT } from '../../constants/contract-types';
import { EMPTY_ENDORSEMENT_DEFAULTS } from './EndorsementUtils';
import { CIVIL_STATUSES } from '../../constants/civil-status';

export const getApprovedCreditLineAmount = (company) => {
  const amount = company?.masterEntity?.creditLinesByType?.[0]
  ?.currentLimit?.newLimit?.amount ?? 0;
  return amount > 0 ? amount : DEFAULT_APPROVED_CREDIT_LINE_AMOUNT;
};

const setContractRequest = (company, setFunc) => {
  if (company.pendingFrameworkContractRequest) {
    setFunc(company.pendingFrameworkContractRequest);
  }
};

const getLegalRepresentatives = (company) => {
  if (company.legalReport.length > 0) {
    return company.legalReport[0].managementPeople;
  }
  return company.legalRepresentative || [];
};

const setMultipleLegalRepresentatives = (company, setFunc) => {
  const lrArray = getLegalRepresentatives(company);
  setFunc(lrArray.map((end, index) => (
    {
      id: index,
      masterEntityId: end.relatedPerson.id,
      label: end.label || 'SR',
      name: end.relatedPerson.name,
      rut: end.relatedPerson.displayNationalIdentifier,
      email: end.email?.toLowerCase() || '',
      nationality: end.nationality?.toLowerCase() || 'chileno',
      profession: end.profession?.toLowerCase() || '',
      civilStatus: end.civilStatus?.toLowerCase() || CIVIL_STATUSES.SINGLE,
      mainDisabled: true,
    })));
};

const setMultipleEndorsements = (company, setFunc) => {
  const endArray = company.endorsements || [];
  setFunc(endArray.map((rep, index) => (
    {
      ...EMPTY_ENDORSEMENT_DEFAULTS,
      id: index,
      masterEntityId: rep.relatedPerson.id,
      label: rep.label || EMPTY_ENDORSEMENT_DEFAULTS.label,
      name: rep.relatedPerson.name,
      rut: rep.relatedPerson.displayNationalIdentifier,
      nationality: rep.nationality?.toLowerCase() || EMPTY_ENDORSEMENT_DEFAULTS.nationality,
      profession: rep.profession?.toLowerCase() || '',
      civilStatus: rep.civilStatus?.toLowerCase() || EMPTY_ENDORSEMENT_DEFAULTS.civilStatus,
      address: rep.address?.toLowerCase() || '',
      email: rep.email?.toLowerCase() || '',
      mainDisabled: true,
      spouceName: rep.relatedSpouce?.name || '',
      spouceLabel: rep.spouceLabel || EMPTY_ENDORSEMENT_DEFAULTS.spouceLabel,
      spouceMasterEntityId: rep.relatedSpouce?.id || null,
      spouceRut: rep.relatedSpouce?.displayNationalIdentifier || '',
      spouceAddress: rep.spouceAddress?.toLowerCase() || '',
      spouceNationality: rep.spouceNationality?.toLowerCase() || '',
      spouceProfession: rep.spouceProfession?.toLowerCase() || '',
      personeriaComments: rep.personeriaComments || '',
      spouceEmail: rep.spouceEmail?.toLowerCase() || '',
    })));
};

const setNaturalPersonLegalRepresentative = (company, setFunc) => {
  setFunc([{
    id: 0,
    masterEntityId: company.masterEntity.id,
    label: 'SR',
    name: company.name,
    rut: company.masterEntity.displayNationalIdentifier,
    email: '',
    nationality: 'chileno',
    profession: '',
    civilStatus: CIVIL_STATUSES.SINGLE,
    mainDisabled: true,
  }]);
};

const setNaturalPersonEndorsement = (company, setFunc) => {
  setFunc([{
    ...EMPTY_ENDORSEMENT_DEFAULTS,
    id: 0,
    masterEntityId: company.masterEntity.id,
    name: company.name,
    rut: company.masterEntity.displayNationalIdentifier,
    address: company.address?.toLowerCase() || '',
    mainDisabled: true,
  }]);
};

const setCurrentLegalReport = (company, setFunc) => {
  if (company.legalReport) {
    setFunc(company.legalReport[0]);
  }
};

const setCurrentPersoneriaComments = (company, setFunc) => {
  if (company.legalReport.length > 0) {
    setFunc({
      personeriaComments: company.legalReport[0].personeriaComments || '',
    });
  }
};

const setInfo = (company, setFunc) => {
  const legalReport = company?.legalReport ? company.legalReport[0] : null;
  const societyType = legalReport?.societyType || '';
  const contractType = company.pendingFrameworkContractRequest?.restriction?.contractType;

  setFunc({
    mainActivity: company.mainActivity?.toLowerCase() || '',
    address: company.address?.toLowerCase() || '',
    rut: company.masterEntity.displayNationalIdentifier,
    societyType,
    name: company.name,
    mainDisabled: true,
    contractType,
    contractTypeLocked: Boolean(contractType),
    fileFormat: FILE_FORMATS.PDF,
  });
};

const HandleResponse = (
  company,
  setContractInfo,
  setLegalRepresentatives,
  setAvailableEndorsements,
  setRelatedContractRequest,
  setLegalReport,
  setPersoneriaComments,
  setApprovedCreditLineAmount,
) => {
  setInfo(company, setContractInfo);
  if (company.isNaturalPerson) {
    setNaturalPersonLegalRepresentative(company, setLegalRepresentatives);
    if (!company.endorsements) {
      setNaturalPersonEndorsement(company, setAvailableEndorsements);
    } else {
      setMultipleEndorsements(company, setAvailableEndorsements);
    }
  } else {
    setMultipleEndorsements(company, setAvailableEndorsements);
    setMultipleLegalRepresentatives(company, setLegalRepresentatives);
  }
  setContractRequest(company, setRelatedContractRequest);
  setCurrentLegalReport(company, setLegalReport);
  setCurrentPersoneriaComments(company, setPersoneriaComments);
  if (setApprovedCreditLineAmount) {
    setApprovedCreditLineAmount(getApprovedCreditLineAmount(company));
  }
};

export default HandleResponse;
